import { Component, Input, SimpleChanges } from '@angular/core';
import { PreviewService } from '@modules/preview/services/preview.service';
import { SrtStats, SrtStatsUI } from '@modules/preview/types/srt-stats';
import { interval, Subject, switchMap, takeUntil, timer } from 'rxjs';

@Component({
    selector: 'app-srt-stats-popover',
    // standalone: true,
    // imports: [],
    templateUrl: './srt-stats-popover.component.html',
    styleUrl: './srt-stats-popover.component.less',
    standalone: false
})
export class SrtStatsPopoverComponent {

  // Inputs
  @Input() recordId?: string;
  @Input() serverId?: string;

  // Public
  public srtStats?: SrtStats;
  public srtStatsUI?: SrtStatsUI;
  public showPopover = false;

  // Private
  private alive = new Subject<void>();

  /**
   * Constructor
   */

  constructor(
    public previewService: PreviewService,
  ) { }

  /**
   * Component lifecycle
   */

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
  }

  ngOnDestroy(): void {
    this.alive.next();
    this.alive.complete();
  }

  /**
   * Methods
   */

  getSrtStats(): void {
    this.alive.next();
    if (this.recordId && this.serverId) {
      timer(0, 1000)
        .pipe(
          switchMap(() => this.previewService.getSrtStats(this.recordId!, this.serverId!)),
          takeUntil(this.alive)
        )
        .subscribe((srtStats) => {
          this.srtStats = srtStats;
          this.srtStatsUI = SrtStatsUI.formatSrtStatsForUI(this.srtStats);
        });
    }
  }

  /**
   * Actions
   */

  show(): void {
    this.showPopover = true;
    this.getSrtStats();
  }

  hide(): void {
    this.showPopover = false;
    this.alive.next();
  }

}
